// Stylesheets
import './sass/style.scss';

// JavaScript
import './js/script.js';
